var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rest touch",
    on: {
      "click": _vm.handleClick
    }
  }, [_vm.restOverride && _vm.configs.restMedia.length > 0 ? _c('div', {
    staticClass: "rest__override"
  }, [_vm.assetType(_vm.configs.restMedia[_vm.restIndex]) === 'video' ? _c('video', {
    staticClass: "rest__background-media",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.configs.restMedia[_vm.restIndex]),
      "autoplay": "",
      "loop": "",
      "disablePictureInPicture": "",
      "muted": "",
      "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
    },
    domProps: {
      "muted": true
    }
  }) : _vm._e(), _vm.assetType(_vm.configs.restMedia[_vm.restIndex]) === 'image' ? _c('img', {
    staticClass: "rest__slide-image",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.configs.restMedia[_vm.restIndex])
    }
  }) : _vm._e()]) : _vm._e(), !_vm.restOverride && _vm.configs.restMedia && _vm.configs.restMedia.length > 0 ? _c('tiny-slider', _vm._b({
    staticClass: "rest__slides"
  }, 'tiny-slider', _vm.sliderConfig, false), _vm._l(_vm.configs.restMedia, function (asset) {
    return _c('div', {
      key: asset
    }, [_vm.assetType(asset) === 'video' ? _c('video', {
      staticClass: "rest__background-media",
      attrs: {
        "src": "".concat(_vm.$store.state.assetsPath).concat(asset),
        "autoplay": "",
        "disablePictureInPicture": "",
        "loop": "",
        "muted": "",
        "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
      },
      domProps: {
        "muted": true
      }
    }) : _vm._e(), _vm.assetType(asset) === 'image' ? _c('img', {
      staticClass: "rest__slide-image",
      attrs: {
        "src": "".concat(_vm.$store.state.assetsPath).concat(asset)
      }
    }) : _vm._e()]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "rest__title"
  }, [_vm._v("\n    " + _vm._s(_vm.configs.restTitle) + "\n  ")]), _vm.touchPrompt ? _c('div', {
    staticClass: "rest__prompt-wrapper",
    style: _vm.touchPrompt
  }, [_c('img', {
    staticClass: "rest__touch-prompt",
    class: {
      'rest__touch-prompt--visible': _vm.showTouchPrompt
    },
    attrs: {
      "src": "/assets/touch-prompt.png"
    }
  }), _c('div', {
    staticClass: "rest__touch-label",
    class: {
      'rest__touch-label--visible': _vm.showTouchPrompt
    },
    domProps: {
      "innerHTML": _vm._s(_vm.configs.restCta)
    }
  })]) : _vm._e(), _vm.configs.restCompanyLogo ? _c('img', {
    staticClass: "rest__company-logo",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.configs.restCompanyLogo)
    }
  }) : _vm._e(), _vm.configs.restDevelopmentLogo ? _c('img', {
    staticClass: "rest__development-logo",
    attrs: {
      "src": "".concat(_vm.$store.state.assetsPath).concat(_vm.configs.restDevelopmentLogo)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "rest__overlay",
    style: "opacity: ".concat(_vm.configs.restOverlay / 100, ";")
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }